<template>
  <div>
    <child />
  </div>
</template>

<script>
import Child from '@components/Layout/Child';

export default {
    name: 'BasicLayout',
    components: {
        Child,
    },
};
</script>
